module.exports = __webpack_public_path__ + "img/log.98b06fa3.png";